/** @flow */
import { combineReducers } from 'redux';
import Estimation from 'common/modules/proposition/domain/estimation';
import type { HistorySalesEstimationState, ProgressSalesEstimationState } from '../domain/state';

import {
  REMOVE_SALES_ESTIMATION_SUCCESS,
  FETCH_ESTIMATION_HISTORY_SUCCESS,
} from '../actions/salesHistoryActions';
import {
  PROPOSE_SALES_ESTIMATION,
  PROPOSE_SALES_ESTIMATION_ERROR,
} from '../actions/salesPropositionActions';
import {
  ESTIMATE_SALES_ASYNC_SUCCESS,
  REMOVE_FROM_NEW_ESTIMATION,
} from '../actions/salesEstimationActions';
import { ESTIMATE_SALES_PROGRESS } from '../actions/salesNotificationsActions';

function addOrReplaceInHistory(state: HistorySalesEstimationState, estimation: Estimation) {
  const history = state.estimations.slice();

  const estimationIdx = history.findIndex(e => e.is(estimation.reference));
  if (estimationIdx >= 0) {
    history[estimationIdx] = estimation;
    return history;
  }

  return [estimation].concat(history);
}

const HISTORY_INITIAL_STATE = { estimations: [] };
function estimationHistoryReducer(state: HistorySalesEstimationState = HISTORY_INITIAL_STATE, action: any) {
  switch (action.type) {
    case REMOVE_FROM_NEW_ESTIMATION: {
      const { estimation } = action;
      return {
        ...state,
        estimations: addOrReplaceInHistory(state, estimation),
      };
    }
    case PROPOSE_SALES_ESTIMATION: // fall-through
    case REMOVE_SALES_ESTIMATION_SUCCESS: {
      const { estimation: { reference } } = action;
      const estimations = state.estimations.filter(estimation => estimation.reference !== reference);

      return {
        ...state,
        estimations,
      };
    }
    case PROPOSE_SALES_ESTIMATION_ERROR:
      return { ...state, estimations: addOrReplaceInHistory(state, action.estimation) };
    case FETCH_ESTIMATION_HISTORY_SUCCESS:
      return { ...state, estimations: action.history };
    default:
      return state;
  }
}

function removeEstimationFromProgress(state: ProgressSalesEstimationState, reference: string) {
  const newState = { ...state };

  Object.keys(state)
    .forEach((station) => {
      newState[station] = state[station].filter(e => e.progress.reference !== reference);
    });

  return newState;
}

const INITIAL_PROGRESS_STATE = {};
function estimationProgressReducer(state: ProgressSalesEstimationState = INITIAL_PROGRESS_STATE, action: any): ProgressSalesEstimationState {
  switch (action.type) {
    case REMOVE_FROM_NEW_ESTIMATION: {
      const { reference } = action.estimation;
      return removeEstimationFromProgress(state, reference);
    }
    case ESTIMATE_SALES_ASYNC_SUCCESS: {
      const { progressRequest } = action;
      const { progress: { callSign } } = progressRequest;

      return { ...state, [callSign]: [progressRequest].concat(state[callSign] || []) };
    }
    case ESTIMATE_SALES_PROGRESS: {
      const { progress } = action;
      const { reference, callSign } = progress;

      const stationProgress = (state[callSign] || []).slice();

      const progressIdx = stationProgress.findIndex(r => r.progress.reference === reference);
      if (progressIdx > -1) {
        stationProgress[progressIdx] = { ...stationProgress[progressIdx], progress };
      }

      return { ...state, [callSign]: stationProgress };
    }
    default:
      return state;
  }
}

export default combineReducers({
  history: estimationHistoryReducer,
  progress: estimationProgressReducer,
});



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/reducer/salesEstimationReducer.js